import { Link } from "react-router-dom";
import { Sparkles, Heart } from "lucide-react";
import { GUESTBOOK } from "@/data/site";

export default function GuestbookSection({ variant = "full" }) {
  const isTeaser = variant === "teaser";

  return (
    <section
      className="bg-bde-pink text-white border-y-2 border-bde-ink relative overflow-hidden"
      data-testid="guestbook-section"
    >
      {/* huge background type */}
      <div className="pointer-events-none select-none absolute inset-x-0 top-1/2 -translate-y-1/2 font-display font-black tracking-[-0.04em] leading-none text-white/10 text-[18vw] text-center whitespace-nowrap">
        ON CAMERA
      </div>

      <div className="container-wide py-24 md:py-32 relative">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* COPY */}
          <div className="lg:col-span-6 order-2 lg:order-1">
            <div className="flex flex-wrap items-center gap-3">
              <span className="inline-flex items-center gap-1 bg-bde-ink text-bde-pink font-mono uppercase tracking-[0.22em] text-[10px] px-3 py-1 rounded-full">
                <Sparkles className="h-3 w-3" /> {GUESTBOOK.badge}
              </span>
              <span className="font-mono uppercase tracking-[0.22em] text-[10px] bg-white text-bde-ink px-3 py-1 rounded-full border-2 border-bde-ink">
                {GUESTBOOK.priceFrom}
              </span>
            </div>

            <h2 className="mt-6 font-display font-black text-5xl md:text-7xl lg:text-[6.5rem] leading-[0.85] tracking-tight">
              {GUESTBOOK.headline}
              <br />
              <span className="italic text-bde-ink">{GUESTBOOK.accent}</span>
            </h2>

            <p className="mt-8 text-lg md:text-xl font-light leading-relaxed text-white/95 max-w-xl">
              {GUESTBOOK.blurb}
            </p>

            <p className="mt-4 font-scribble text-3xl md:text-4xl text-bde-ink leading-tight max-w-xl">
              {GUESTBOOK.ps}
            </p>

            {!isTeaser && (
              <ul className="mt-10 grid sm:grid-cols-2 gap-x-6 gap-y-3 max-w-xl">
                {GUESTBOOK.highlights.map((h) => (
                  <li key={h} className="flex items-start gap-2 text-sm leading-snug">
                    <Heart className="h-4 w-4 mt-0.5 fill-bde-ink stroke-bde-ink flex-shrink-0" />
                    <span>{h}</span>
                  </li>
                ))}
              </ul>
            )}

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <Link
                to="/booth"
                data-testid="guestbook-cta-more"
                className="inline-flex items-center gap-2 bg-bde-ink text-white font-mono uppercase tracking-[0.18em] text-xs md:text-sm px-6 py-4 border-2 border-bde-ink hover:bg-white hover:text-bde-ink transition-all duration-150"
              >
                See the whole booth →
              </Link>
            </div>
          </div>

          {/* PHOTO STACK */}
          <div className="lg:col-span-6 order-1 lg:order-2">
            <div className="grid grid-cols-2 gap-3 md:gap-4 max-w-xl mx-auto">
              {GUESTBOOK.images.slice(0, isTeaser ? 4 : 6).map((src, i) => {
                const isTall = i === 0 || i === 3 || i === 5;
                const rotations = ["-3deg", "2deg", "-2deg", "3deg", "-1deg", "2.5deg"];
                return (
                  <div
                    key={src}
                    style={{ transform: `rotate(${rotations[i % rotations.length]})` }}
                    className={`bg-white p-2 border-2 border-bde-ink shadow-[6px_6px_0px_#11100F] ${isTall ? "row-span-2" : ""}`}
                  >
                    <img
                      src={src}
                      alt="Video guestbook booth"
                      className={`w-full ${isTall ? "h-72 md:h-96" : "h-40 md:h-44"} object-cover`}
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
